/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageShelterListPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/dom-style',
        'dojo/text!./templates/SignageShelterListPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        //'../../config',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageShelterListPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageShelterListPage~SignageShelterListPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 6,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'municOpeningShelterNum', 'area':'municOpeningShelterNumArea'},
                {'item':'municEvacHouseholdNum', 'area':'municEvacHouseholdNumArea'},
                {'item':'municEvaqueeNum', 'area':'municEvaqueeNumArea'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setShelterListInfo();
            },

            /**
             * 個別避難所情報を設定します
             */
            setShelterListInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 避難所情報を設定
                    var municShelterInfo = item.items.filter(function(element) {
                        return element.districtCd === null;
                    });
                    this.setMunicShelterInfo(this, municShelterInfo);
                    var shelterList = item.items.filter(function(element) {
                        return element.districtCd !== null;
                    });
                    this.setShelterList(this, shelterList);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var municShelterInfo = {};
                        this.setDamageOverview(this, municShelterInfo);
                        var shelterList = [];
                        this.setShelterList(this, shelterList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 市町村の避難所情報を設定します
             */
            setMunicShelterInfo: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item];
                });

                // 集計エリアのタイトルを設定
                var aggrigateAreaTitleStr = '';
                if (item[0].municipalityCd === null || item[0].municipalityCd === '') {
                    aggrigateAreaTitleStr = '県内合計';
                } else {
                    aggrigateAreaTitleStr = '市内合計（' + item[0].municipalityName + '）';
                } 
                self.aggrigateAreaTitle.innerHTML =  aggrigateAreaTitleStr;

                // 更新状態を設定
                this.setMunicShelterInfoUpdate(self, item);
            },

            /**
             * 市町村の避難所情報の更新状態を設定します
             */
            setMunicShelterInfoUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var municShelterInfo = prevItem.items[0];
                if (municShelterInfo) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (municShelterInfo[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 避難所情報一覧を設定します
             */
            setShelterList: function(self, data) {
                // 表示をクリア
                var shelterListTBody = dojo.byId('shelterListTBody');
                domConstruct.empty(shelterListTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                if (data.length <= this.PAGE_LIST_SIZE) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);    
                }

                var prevItem = prevItemStore[this._screenId];
                var shelterList = [];
                if (prevItem) {
                    shelterList = prevItem.items.filter(function(element) {
                        return element.districtCd !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){
                    // 避難所の前回値
                    var shelterPrevItem = null;
                    if (shelterList && shelterList.length > 0) {
                        shelterPrevItem = shelterList.filter((element) =>
                            element.shelterId === item.shelterId
                        )[0];
                        // 新規のデータが追加された場合は前回値を0として設定
                        if (shelterPrevItem === undefined) {
                            shelterPrevItem = {"facilityName": "", "status": "", "shelterStartTimestamp": "", "evaqueeNum":"", "shelterCategory":"", "updTimestamp":""};
                        }
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');

                    // 地区
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.districtName, class: 'align-middle text-center fw-bold first-col'}), tr);

                    // 避難所名
                    className = shelterPrevItem && (shelterPrevItem.facilityName !== item.facilityName) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.facilityName, class: className}), tr);

                    // ステータス（混雑状況）
                    className = shelterPrevItem && ((shelterPrevItem.status !== item.status)||(shelterPrevItem.crowdedStatus !== item.crowdedStatus)) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    var crowdedStatus = '';
                    var dispStatusString = '';
                    var addStyle = '';
                    switch (item.crowdedStatus) {
                        case '1':
                            crowdedStatus = '<br>（空き）';
                            addStyle = 'open-capacity-under';
                            break;
                        case '2':
                            crowdedStatus = '<br>（やや混雑）';
                            addStyle = 'open-capacity-slightlyCrowded';
                            break;
                        case '3':
                            crowdedStatus = '<br>（混雑）';
                            addStyle = 'open-capacity-crowded';
                            break;
                        case '4':
                            crowdedStatus = '<br>（定員一杯）';
                            addStyle = 'open-capacity-over';
                            break;
                        case '9':
                            crowdedStatus = '<br>（不明）';
                            addStyle = 'open-capacity-unknown';
                            break;
                    }
                    switch (item.status) {
                        case '0':
                            dispStatusString = '開設準備中';
                            break;
                        case '1':
                            dispStatusString = '開設済' + crowdedStatus;
                            className = className + ' ' + addStyle;
                            break;
                        case '9':
                            dispStatusString = '閉鎖';
                            className = className + ' close';
                            break;
                    }
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: dispStatusString, class: className}), tr);

                    // 開設/閉鎖日時
                    className = shelterPrevItem && ((shelterPrevItem.shelterStartTimestamp !== item.shelterStartTimestamp)||(shelterPrevItem.shelterEndTimestamp !== item.shelterEndTimestamp)) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    var dispTimestampString = '';
                    if (item.status === '9') {
                        dispTimestampString = item.shelterEndTimestamp;
                    } else {
                        dispTimestampString = item.shelterStartTimestamp;
                    }
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: dispTimestampString, class: className}), tr);

                    // 避難者数（最大収容人数）
                    className = shelterPrevItem && (shelterPrevItem.evaqueeNum !== item.evaqueeNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.evaqueeNum + '人<br>（' + item.capacity + '）', class: className}), tr);

                    // 避難所区分
                    className = shelterPrevItem && (shelterPrevItem.shelterCategory !== item.shelterCategory) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.shelterCategory, class: className}), tr);
                    domConstruct.place(tr, shelterListTBody);

                    // 更新日時
                    className = shelterPrevItem && (shelterPrevItem.updTimestamp !== item.updTimestamp) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.updTimestamp, class: className}), tr);
                    domConstruct.place(tr, shelterListTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setShelterList(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
    });
